"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RevoltingColonists = void 0;
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const MoonExpansion_1 = require("../../moon/MoonExpansion");
const TileType_1 = require("../../TileType");
const CardRenderer_1 = require("../render/CardRenderer");
const CardRequirements_1 = require("../CardRequirements");
const Card_1 = require("../Card");
const Size_1 = require("../render/Size");
class RevoltingColonists extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.REVOLTING_COLONISTS,
            cardType: CardType_1.CardType.EVENT,
            tags: [Tags_1.Tags.MOON],
            cost: 3,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.colonyRate(4)),
            metadata: {
                description: 'Requires 4 Colony Rate. All players pay 3M€ for each colony tile they own.',
                cardNumber: 'M51',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.megacredits(3).any.slash().nbsp(Size_1.Size.SMALL).moonColony().any;
                }),
            },
        });
    }
    ;
    play(player) {
        const colonies = MoonExpansion_1.MoonExpansion.tiles(player.game, TileType_1.TileType.MOON_COLONY);
        player.game.getPlayers().forEach((colonyTileOwner) => {
            const owned = colonies.filter((colony) => { var _a; return ((_a = colony.player) === null || _a === void 0 ? void 0 : _a.id) === colonyTileOwner.id; }).length;
            if (owned > 0) {
                const owes = owned * 3;
                const spent = Math.min(owes, colonyTileOwner.megaCredits);
                colonyTileOwner.megaCredits -= spent;
                player.game.log('${0} spends ${1} M€ for the ${2} colonies they own.', (b) => b.player(colonyTileOwner).number(spent).number(owned));
            }
        });
        return undefined;
    }
}
exports.RevoltingColonists = RevoltingColonists;
//# sourceMappingURL=RevoltingColonists.js.map